export const getHeaderClassName = <T extends { [key: string]: boolean }>(
    sortFieldName: string,
    desc: T | null,
    title: string,
) => {
    return sortFieldName === title ? (desc?.[title] ? 'desc' : 'no_desc') : '';
};
